import { createContext } from 'react'

export type ErrorHandlerProps = {
  close: () => void;
  open: (error: unknown) => void;
  isOpen: boolean;
  error: unknown;
};

export const ErrorHandlerContext = createContext<ErrorHandlerProps | null>(null);